import { Brick, registerBrick } from 'olympe';

export default class ReadAndFormatData extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} data
     * @param {function()} forwardEvent
     * @param {function(string)} setFormatted
     */
    update($, [data], [forwardEvent, setFormatted]) {
        const resultMap = new Map();

        for (const [prNumber, frontendIds] of data.frontendsCheckingAPR) {
            // For each PR, transform frontendIds into userInfos
            const userInfosWithDuplicates = frontendIds
                .map((frontendId) => data.frontendIdUserLink.get(frontendId))
                .filter(Boolean); // Remove undefined entries

            // Keep first occurrence of each userId while maintaining order
            const seenUserIds = new Set();
            const uniqueUserInfos = userInfosWithDuplicates.filter((userInfo) => {
                if (seenUserIds.has(userInfo.userId)) {
                    return false; // Skip this duplicate
                }
                seenUserIds.add(userInfo.userId);
                return true;
            });

            resultMap.set(prNumber, uniqueUserInfos);
        }

        setFormatted(resultMap);
        forwardEvent();
    }
}

registerBrick('0198ccaaac0ba3623175', ReadAndFormatData);
